import { MajorEventsLandingQuery } from '@layouts/major-events-landing'

const MajorEventsLandingPage = (props) => {
  return <MajorEventsLandingQuery {...props} />
}

MajorEventsLandingPage.getInitialProps = async ({ query }) => {
  return ({ query })
}

export default MajorEventsLandingPage
